module.exports = __webpack_public_path__ + "img/754ef09.png";